import { Component, OnInit,ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder,FormControl, Validators,AbstractControl, FormArray } from '@angular/forms';
import { Invoice } from 'app/shared/types/invoice';
import { ActivatedRoute,Router} from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from 'app/shared/services/dialog.service';
import { InvoiceService } from 'app/shared/services/invoice.service';
import { ReceiptService } from 'app/shared/services/receipt.service';
import { QuotationService } from 'app/shared/services/quotation.service';
import { ItemService } from 'app/shared/services/item.service';
import { VehicleRegisterService } from 'app/shared/services/vehicle-register.service';
import { LocationService } from 'app/shared/services/location.service';
import { ContainerTypeService } from 'app/shared/services/container-type.service';
import { CustomerService} from 'app/shared/services/customer.service';
import { AuthService } from 'app/shared/services/auth.service';
import { map, startWith, isEmpty} from 'rxjs/operators';
import { Observable} from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { BsDatepickerConfig} from 'ngx-bootstrap/datepicker';
import { CanvasImageService} from 'app/shared/services/canvas-image.service';
import { CompanyProfileService } from 'app/shared/services/company-profile.service';
import { FileUploadService } from 'app/shared/services/file-upload.service';
import { MatDialogConfig } from '@angular/material/dialog';
import { DecimalPipe } from '@angular/common';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import * as moment from 'moment';
import { NbThemeService } from '@nebular/theme';
import { FileUploadComponent } from '../../../file-upload/file-upload.component';
import { BankAccountsService} from 'app/shared/services/bank-accounts.service';
import { LocationComponent } from '../../../master-files/location/location.component';
import { ContainerTypeComponent } from '../../../master-files/container-type/container-type.component';





@Component({
  selector: 'app-add-invoice',
  templateUrl: './add-invoice.component.html',
  styleUrls: ['./add-invoice.component.css'],
})
export class AddInvoiceComponent implements OnInit {

  datepickerConfig : Partial<BsDatepickerConfig>
  datepickerConfigDate : Partial<BsDatepickerConfig>
  defaultDate : Date = new Date();
  isDark: boolean = false;


  paymentType:string=null;;
  depositAccount:string=null;
  isPaidChecked = false;
  bankAccountList : any[];

  vehicleList:any;
  locationList:any;
  containerTypeList:any;

   crud_access = {
     read: null,
     create: null,
     approve: null,
     delete: null,
     createReceipt:null,
    };

  itemList : any[]=[];
  filteredOptions:  Observable<any[]>[] = [];

  filteredCustomerList: Observable<any[]>;
  customerList : any[];
  warehouseList: any[];
  salesRepList: any[];
  invoice:Invoice;
  invoiceData = [];
  stockData = [];
  receiptData = [];
  receiptNo : string  = null;
  invoiceForm: FormGroup;
  isfieldReadOnly : boolean= true;
  isfieldReceivedReadOnly : boolean= true;
  isBtnDisabled : boolean= true;
  isEditBtnDisabled : boolean= true;
  isCancelBtnDisabled : boolean= true;
  isHideBtn: boolean= false;
  isShowAttachBtn: boolean=false;
  isShowPayBtn: boolean=false;
  showInvoicePmtDetails : boolean= false;
  bsClassToShow : boolean = false;
  isEditDiscRate : boolean = false;
  selectChkBox : boolean = false;
  isValidFormData: boolean = true;
  showProcessingIndicator =false;

  companyData : any  = [];
  logo :any;

  HIRE_TYPE = [
    {value: 'Import'},
    {value: 'Export'},
    {value: 'Transfer'},
  ];

  HIRE_MODE = [
    {value: 'LCL'},
    {value: 'FCL'},
  ];

   VEHICLE_TYPE= [
    {value: 'Owned'},
    {value: 'Rented'},
  ];


  PMT_TERM =[
    {value: 'COD'},
    {value: '7 Days'},
    {value: '15 Days'},
    {value: '21 Days'},
    {value: '30 Days'},
    {value: '45 Days'},
    {value: '60 Days'},
    {value: '90 Days'},
    {value: '120 Days'},
  ];



  PMT_METHOD =[
    {value: 'Cash'},
    {value: 'Cheque'},
    {value: 'Card Payment'},
    {value: 'Bank Transfer'},

  ];

  validationMessages = {
    'invoiceNo' : { 'required': 'This field is required' },
    'invoiceDate' : { 'required': 'This field is required' },
    'invoiceType' : { 'required': 'This field is required' },
    'cusId' : { 'required': 'This field is required' },
    'cusName' : { 'required': 'This field is required' },
    'address' : { 'required': 'This field is required' },
    'vehicle' : { 'required': 'This field is required' },
    'vehicleType' : { 'required': 'This field is required' },
    'containerType' : { 'required': 'This field is required' },
    'fromLocation' : { 'required': 'This field is required' },
    'toLocation' : { 'required': 'This field is required' },
    'hireType' : { 'required': 'This field is required' },
    'hireMode' : { 'required': 'This field is required' },
    'requestTime' : { 'required': 'This field is required' },
    'factoryInTime' : { 'required': 'This field is required' },
    'detentionStartTime' : { 'required': 'This field is required' },
    'finishedTime' : { 'required': 'This field is required' },
    'chargingHours' : { 'required': 'This field is required' },
    'paymentTerm' : { 'required': 'This field is required' },
   
  };

  formErrors = {
    'invoiceNo' : "",
    'invoiceDate' : "",
    'invoiceType' : "",
    'cusId' : "",
    'cusName' : "",
    'address' : "",
    'vehicle' : "",
    'vehicleType' : "",
    'containerType' : "",
    'fromLocation' : "",
    'toLocation' : "",
    'hireType' : "",
    'hireMode' : "",
    'requestTime' : "",
    'factoryInTime' : "",
    'detentionStartTime' : "",
    'finishedTime' : "",
    'chargingHours' : "",
    'paymentTerm' : "",

  };


  constructor(private fb: FormBuilder,
        private invoiceService: InvoiceService,
        private fileUploadService:FileUploadService,
        private bankAccountsService: BankAccountsService,
        private authService: AuthService,
        private toastr: ToastrService,
        private dialogService: DialogService,
        private itemService : ItemService,
        private route : ActivatedRoute,
        private router : Router, 
        private customerService : CustomerService,
        private vehicleRegisterService :VehicleRegisterService,
        private locationService : LocationService,
        private containerTypeService :ContainerTypeService,
        private receiptService :ReceiptService,
        private decimalPipe: DecimalPipe,
        private companyProfileService: CompanyProfileService,
        private themeService: NbThemeService,
        private canvasImageService  : CanvasImageService )
      {
        this.datepickerConfig = Object.assign({},
          {   
            showWeekNumbers:false,
            dateInputFormat : 'YYYY-MM-DD  HH:mm'
            //'YYYY-MM-DD HH:mm'
          });

          this.datepickerConfigDate = Object.assign({},
            {   
              showWeekNumbers:false,
              dateInputFormat : 'YYYY-MM-DD'
            });
      }

  ngOnInit() {
 
      this.initInvoceType();
      this.initFormFields();
      this.getCompanyDetails();
      this.getBankAccountList();
      this.getVehicleList();
      this.getAllLocations();
      this.getAllContainerType();
      this.getItemList();

      this.disableForm();
   
      this.getCustomerList();
      this.viewInvoiceById();
 
      this.getControlPermissions();
  
      this.autoCompleteCustomer();

      this.invoiceForm.valueChanges.subscribe((data) => {
        this.logValidationErrors(this.invoiceForm);
        });

  

        this.themeService.onThemeChange()
        .subscribe(themeName =>{
             this.isDark  = themeName.name ==='dark' ? true : false;
           });

  }// end oninit

  getControlPermissions(){
    var data = [];
    var data2 = [];
     data =  this.authService.controlPermissionArray.filter((el)=>{
      return el.moduleCode ==='INV'
    });
    if(data.length > 0){
      this.crud_access.read = data[0].read;
      this.crud_access.create = data[0].create;
      this.crud_access.approve = data[0].approve;
      this.crud_access.delete = data[0].delete;
    }

    data2 =  this.authService.controlPermissionArray.filter((el)=>{
      return el.moduleCode ==='RECEIPT'
    });
    if(data2.length > 0){
      this.crud_access.createReceipt = data2[0].create;

    }

  }

  loadLogo(){
    
    if(this.companyData.length===1){
      if(this.companyData[0].Logo){
        let TYPED_ARRAY = new Uint8Array(this.companyData[0].Logo.data);
        const STRING_CHAR = TYPED_ARRAY.reduce((data,byte) =>{
          return data + String.fromCharCode(byte);
        },'');
        let base64String = btoa(STRING_CHAR);
        this.logo = 'data:image/jpeg;base64,' + base64String;
       }else{
        this.logo =null;
       }
  
       if(this.companyData[0].DigitalSignature){
        let TYPED_ARRAY = new Uint8Array(this.companyData[0].DigitalSignature.data);
        const STRING_CHAR = TYPED_ARRAY.reduce((data,byte) =>{
          return data + String.fromCharCode(byte);
        },'');
        let base64String = btoa(STRING_CHAR);
        //this.signature = 'data:image/jpeg;base64,' + base64String;
       }else{
        //this.signature =null;
       }

    } 
  
   
  }

  getVehicleList(){
    this.vehicleRegisterService.getAll()
     .subscribe(
        (data) => {
                  this.vehicleList = data; 
                  },
       (err) => 
                {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                 });  
       
     }

     getAllLocations(){
      this.locationService.getAll()
       .subscribe(
          (data) => {
                    this.locationList = data;    
                    },
         (err) => 
                  {
                    if(err instanceof HttpErrorResponse){                 
                      if(err.status == 401){
                        this.router.navigate(['/login']);
                      }
                    }
                    console.log(err);
                  });  
  
         
         
       }


       getAllContainerType(){
        this.containerTypeService.getAll()
         .subscribe(
            (data) => {
                      this.containerTypeList = data;    
                      },
           (err) => 
                    {
                      if(err instanceof HttpErrorResponse){                 
                        if(err.status == 401){
                          this.router.navigate(['/login']);
                        }
                      }
                      console.log(err);
                    });  
    
           
           
         }

  getCompanyDetails(){

    this.companyProfileService.getCompanyDetails()
    .subscribe(
      (data) =>{

                this.companyData = data;   
                this.loadLogo();         

                },
      (err) => {
        if(err instanceof HttpErrorResponse){                 
          if(err.status == 401){
            this.router.navigate(['/login']);
          }
        }
        console.log(err);
      }
    );
  
  }
  
 
  autoComplete(index: number){
    this.filteredOptions[index] =this.getInvoiceItems.at(index).get('itemCode').valueChanges
    .pipe(
      startWith(''),
        map(value => this._filter(value))
    );

  }

  autoCompleteCustomer(){
      this.filteredCustomerList = this.invoiceForm.get('cusName').valueChanges
      .pipe(
        startWith(''),
        map(value => this._filterCustomer(value))
      ); 
  }

  private _filter(itemCode: string): any[] {
    if(itemCode){
    const filterValue = itemCode.toLowerCase();
    return this.itemList.filter(option => option.ItemCode.toLowerCase().indexOf(filterValue) === 0);
    }
  }

  
  private _filterCustomer(cusName: string): any[] {
    if(cusName){
       const filterValue = cusName.toLowerCase();
       return this.customerList.filter(option => option.CusName.toLowerCase().indexOf(filterValue) === 0);
    }
  }

  getItemData(i){
    var filteredData;
    var value  = this.getInvoiceItems.at(i).get('itemCode').value;
    if(value){
    filteredData = this.itemList.filter(itemList =>itemList.ItemCode.toLowerCase()===value.toLowerCase());
    if(filteredData.length ===1){
      this.getInvoiceItems.at(i).patchValue({ 
        description : filteredData[0].Description,
        salesType : filteredData[0].Category,
        unitCost : filteredData[0].UnitCost,
        unitPrice:  filteredData[0].UnitPrice,
        qty :'1.00', 
        amount : filteredData[0].UnitPrice,
      });   
    }else{
      this.getInvoiceItems.at(i).patchValue({ 
        description : '',
        salesType :  '',
        unitCost : '',
        unitPrice:  '',
        qty: '',
        amount : '',
      });     

    }
  }
}




getCustomerDetails(){      
  var filteredData;
  var cusName = this.invoiceForm.value.cusName;
  if(cusName){
  filteredData = this.customerList.filter(data =>data.CusName.toLowerCase()===cusName.toLowerCase());
   if(filteredData.length ===1){
     this.getJobNo(filteredData[0].CusId);
     this.invoiceForm.patchValue({
       cusId : filteredData[0].CusId,
       address :filteredData[0].Address,
       vatNo :filteredData[0].VATNo,
       svatNo :filteredData[0].SVATNo,
     });
   }else{
    this.invoiceForm.patchValue({
      cusId : null,
      address :null,
      vatNo :null,
      svatNo :null,
      jobNo :null,

    });
   }
  }
}
     

  
getItemList(){
  this.itemService.getAll()
 .subscribe(
    (data) => {
              this.itemList = data                
              },
   (err) => 
            {
              if(err instanceof HttpErrorResponse){                 
                if(err.status == 401){
                  this.router.navigate(['/login']);
                }
              }
              console.log(err);
            });  
   
 }

  getCustomerList(){
  this.customerService.getAll()
   .subscribe(
      (data) => {
                this.customerList = data.filter((el)=>{
                  return el.Status !=="Deactivated";
                });             
                },
     (err) => 
              {
                if(err instanceof HttpErrorResponse){                 
                  if(err.status == 401){
                    this.router.navigate(['/login']);
                  }
                }
                console.log(err);
              });  
     
   }

   getBankAccountList(){
    this.bankAccountsService.getAllBankAccounts()
     .subscribe(
        (data) => {  
                  this.bankAccountList = data           
                  },
       (err) => 
                {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                });  
       
     }



  initInvoceType() : void{

    this.invoice = {
      id : null,
      invoiceNo: '',
      invoiceDate: '',
      invoiceType: '',
      cusId: '',
      cusName: '',
      address: '',
      factoryLocation: '',
      requestedBy: '',
      vatNo: '',
      svatNo: '',
      vehicle: '',
      poNo: '',
      vehicleType: '',
      containerType: '',
      containerNo: '',
      fromLocation: '',
      toLocation: '',
      hireType: '',
      hireMode: '',
      requestTime: '',
      factoryInTime: '',
      detentionStartTime: '',
      finishedTime: '',
      chargingHours: 0.00,
      jobNo: '',
      paymentTerm: '',
      dueDate: '',
      itemCode: '',
      description: '',
      salesType: '',
      unitPrice: 0.00,
      qty: 0.00,
      amount: 0.00,
      subTotal: 0.00,
      vat: 0.00,
      grandTotal: 0.00,
      totalCost: 0.00,
      totalProfit: 0.00,
      balToPay: 0.00,
      amountPaid: 0.00,
      remarks: '',
      status: '',
      type: '',
      refNo: '',
      createdBy: '',
      

    };

    this.paymentType=null;
    this.depositAccount=null;
  }


  initFormFields() : void{
    this.invoiceForm = this.fb.group({
      id : [null],
      invoiceNo: ['',Validators.required],
      invoiceDate: ['',Validators.required],
      invoiceType: ['INVOICE',Validators.required],
      cusId: ['',Validators.required],
      cusName: ['',Validators.required],
      address: ['',Validators.required],
      factoryLocation: [''],
      requestedBy: [''],
      vatNo: [''],
      svatNo: [''],
      vehicle: ['',Validators.required],
      vehicleType: [null,Validators.required],
      containerType: [null,Validators.required],
      containerNo: [''],
      fromLocation: [null,Validators.required],
      toLocation: [null,Validators.required],
      hireType: [null,Validators.required],
      hireMode: [null,Validators.required],
      requestTime: ['',Validators.required],
      factoryInTime: ['',Validators.required],
      detentionStartTime: ['',Validators.required],
      finishedTime: ['',Validators.required],
      chargingHours: ['',Validators.required],
      jobNo: [''],
      paymentTerm: ['',Validators.required],
      poNo :[''],
      remarks :[''],

      invoiceItems : this.fb.array([this.addInvoiceItem()]), 

       
    });


  }


  newButtonClick(): void {
    this.isfieldReadOnly  = false;
    this.selectChkBox= false;
    this.isBtnDisabled = false;
    this.isEditBtnDisabled = true;
    this.isCancelBtnDisabled = true;
    this.isHideBtn = false;
    this.isShowAttachBtn=false;
    this.isShowPayBtn=false;
  
    this.invoiceForm.reset();
    this.resetOtherControls();
    this.enableForm();
    this.getMaxId('INVOICE');
    this.addItemButtonClick();
    this.invoiceForm.patchValue({
      invoiceDate:  this.defaultDate,
      invoiceType:  'INVOICE'
    });
     
   }

   editButtonClick(): void {
    this.isBtnDisabled = false;   
    this.isfieldReadOnly =false;
    this.isHideBtn =  false;
    this.enableForm();
    this.showInvoicePmtDetails = false;
    this.bsClassToShow = false;
   }

   getMaxId(id){
    var invoiceNo = 0;
    var invNoPrefixZero  : String;
    let year =moment().format("YY");
    let invPrefix = "MFS/";
    this.invoiceService.getMaxId(id)
    .subscribe(
      (res) => {

          if(id==='INVOICE') invPrefix="MFS/";
          if(id==='VAT INVOICE') invPrefix="MFS/VAT/";
          if(id==='SVAT INVOICE') invPrefix="MFS/SVAT/";

          invoiceNo = Number(res[0].InvoiceNo) + 1;
          invNoPrefixZero = invoiceNo.toString().padStart(5,'0');       
          this.invoiceForm.patchValue({
            invoiceNo : `${invPrefix}${invNoPrefixZero}/${year}` 
          });
         
      },        
      (err) =>  {
              if(err instanceof HttpErrorResponse){                 
                if(err.status == 401){
                  this.router.navigate(['/login']);
                }
              }
              console.log(err);
          }, 
      )

   }

   getJobNo(id){
    var jobNo = 0;
    this.invoiceService.getJobNo(id)
    .subscribe(
      (res) => {
          jobNo = Number(res[0].JobNo) + 1; 
          this.invoiceForm.patchValue({
            jobNo : jobNo,
          });
         
      },        
      (err) =>  {
              if(err instanceof HttpErrorResponse){                 
                if(err.status == 401){
                  this.router.navigate(['/login']);
                }
              }
              console.log(err);
          }, 
      )

   }

   getMaxReceiptId(){
    var receiptNo = 0;
    var receiptNoPrefixZero  : String;
  
    this.receiptService.getMaxId()
    .subscribe(
      (res) => {
          receiptNo = Number(res[0].ReceiptNo) + 1;
          receiptNoPrefixZero = receiptNo.toString().padStart(6,'0');               
          this.receiptNo = "CPMT" + receiptNoPrefixZero;
        
         
      },        
      (err) =>  {
              if(err instanceof HttpErrorResponse){                 
                if(err.status == 401){
                  this.router.navigate(['/login']);
                }
              }
              console.log(err);
            }, 
      )

   }

   fromLocationChangeEvent(event){
    if(event.target.selectedIndex===1){
      this.invoiceForm.patchValue({fromLocation :null});
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      dialogConfig.autoFocus = true;
      dialogConfig.width = "70%";
      this.dialogService.openDialog(LocationComponent,dialogConfig)
      .afterClosed().subscribe(res =>{
        this.getAllLocations();
      }); 
    }
   
  }
  
   toLocationChangeEvent(event){
     if(event.target.selectedIndex===1){
       this.invoiceForm.patchValue({toLocation :null});
       const dialogConfig = new MatDialogConfig();
       dialogConfig.disableClose = true;
       dialogConfig.autoFocus = true;
       dialogConfig.width = "70%";
       this.dialogService.openDialog(LocationComponent,dialogConfig)
       .afterClosed().subscribe(res =>{
        this.getAllLocations();
       }); 
     }
    
   }

  

   containerTypeChangeEvent(event){
    if(event.target.selectedIndex===1){
      this.invoiceForm.patchValue({containerType :null});
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      dialogConfig.autoFocus = true;
      dialogConfig.width = "70%";
      this.dialogService.openDialog(ContainerTypeComponent,dialogConfig)
      .afterClosed().subscribe(res =>{
       this.getAllContainerType();
      }); 
    }
   
  }




  getChargableHours(){
    if(this.invoiceForm.value.detentionStartTime && this.invoiceForm.value.finishedTime){
        let dst = moment(this.invoiceForm.value.detentionStartTime,'YYYY-MM-DD HH:mm');
        let ft  = moment(this.invoiceForm.value.finishedTime,'YYYY-MM-DD HH:mm');

        let duration = moment.duration(ft.diff(dst));
        let hours = duration.asHours();

        this.invoiceForm.patchValue({chargingHours :hours.toFixed(2)});

      }

  }

  checkedChangeRdoButtons(event){
      this.getMaxId(event.value);
  }

  
   addInvoiceItem() : FormGroup{
     
    return this.fb.group({
     itemCode : ['',Validators.required],
     description : ['',Validators.required],
     salesType : [''],
     unitCost : [''],
     unitPrice :['',Validators.required],
     qty : ['',Validators.required],
     amount : ['',Validators.required],

    });
   
  }


   get getInvoiceItems(){
      return this.invoiceForm.get('invoiceItems') as FormArray;
   }

//    calculateDiscount(){
//     let discount = 0.00;
//     if(this.invoice.discRate){
//       discount = parseFloat((this.invoice.subTotal * this.invoice.discRate /100).toFixed(2))   
//     }
//     //this.invoice.discount = parseFloat(this.decimalPipe.transform(discount,'1.2-2'));
//     this.invoice.discount = discount;
//     if(this.getInvoiceItems.length < 1){
//       this.invoice.discRate = null;
//     }

//     this.updateBillTotal();
  
//  }

  //  calculateDiscountPerc(){
  //     let discPerc = null;
  //     if(this.invoice.discount){
  //       discPerc= (this.invoice.discount /this.invoice.subTotal * 100).toFixed(2);
  //     }
  //     this.invoice.discRate = discPerc;
  //     if(this.getInvoiceItems.length < 1){
  //       this.invoice.discount= null;
  //     }

  //     this.updateBillTotal();
    
  //  }

  isNumeric(value){
    if(!isNaN(value) &&  !isNaN(parseFloat(value))){
      return true;
    } 
     return false;
  
  }


   receivedFieldFocusOut(){
    if(this.invoice.amountPaid==0 || !this.isNumeric(this.invoice.amountPaid)){
      this.selectChkBox = false;
      this.invoice.amountPaid = 0.00;
      this.isfieldReceivedReadOnly = true;
      this.receiptNo = null;
      this.paymentType=null;;
      this.depositAccount=null;
      this.isPaidChecked = false;
    }

    this.updateBillTotal();

   }

   selectReceivedAmountCheckBoxChange(event){
    if(event.checked){
      this.isPaidChecked = true
      this.getMaxReceiptId();
      this.isfieldReceivedReadOnly  = false;
      this.invoice.amountPaid = this.invoice.grandTotal;     
    }
    else{
      this.invoice.amountPaid = 0.00;
      this.isfieldReceivedReadOnly  = true;
      this.receiptNo = null;
      this.paymentType=null;;
      this.depositAccount=null;
      this.isPaidChecked = false;
    }

    this.updateBillTotal();

  }

   addItemButtonClick() : void {
          this.getInvoiceItems.push(this.addInvoiceItem());
          this.autoComplete(this.getInvoiceItems.length-1);    
         // this.calculateDiscount();
          this.selectChkBox = false;
          this.invoice.amountPaid = 0.00;
          this.isfieldReceivedReadOnly  = true;
          this.receiptNo = null;
          this.updateBillTotal();    
  }

    removeItemButtonClick(itemIndex : number) : void{
      this.getInvoiceItems.removeAt(itemIndex);
      this.filteredOptions.splice(itemIndex, 1);
     // this.calculateDiscount();
      this.selectChkBox = false;
      this.invoice.amountPaid = 0.00;
      this.isfieldReceivedReadOnly  = true;
      this.receiptNo = null;
      this.updateBillTotal();

    }

    resetOtherControls() : void{
        while (this.getInvoiceItems.length !== 0) {
          this.getInvoiceItems.removeAt(0);
        }

        this.invoice.subTotal = 0.00;
        this.invoice.vat = 0.00;
        this.invoice.grandTotal = 0.00;
        this.invoice.amountPaid = 0.00;
        this.invoice.balToPay = 0.00;
        this.receiptNo = null;
        this.showInvoicePmtDetails = false;
        this.bsClassToShow = false;
        this.paymentType=null;;
        this.depositAccount=null;
    }


 
  
    calEachItemAmount(i){
      var unitPrice : number;
      var qty : number;
      var amount : number=0;
      
      var itemCode  = this.getInvoiceItems.at(i).get('itemCode').value
      if(itemCode){

      unitPrice = this.isNumeric(this.getInvoiceItems.at(i).get('unitPrice').value) ? parseFloat(this.getInvoiceItems.at(i).get('unitPrice').value) :null;
      qty = this.isNumeric(this.getInvoiceItems.at(i).get('qty').value) ?  parseFloat(this.getInvoiceItems.at(i).get('qty').value) : null;
      amount = (this.isNumeric(unitPrice) && this.isNumeric(qty)) ? parseFloat((unitPrice * qty).toFixed(2)) : null;

      this.getInvoiceItems.at(i).patchValue({unitPrice : unitPrice});
      this.getInvoiceItems.at(i).patchValue({qty : qty});
      this.getInvoiceItems.at(i).patchValue({amount : amount});


      }
  
      this.updateBillTotal();
    }

      


  updateBillTotal(){
    this.invoice.grandTotal  = +this.getInvoiceItems.value.reduce((prev,curr)=>prev + +curr.amount, 0);
    this.invoice.vat = 0.00;    
    this.invoice.balToPay = +this.invoice.grandTotal - +this.invoice.amountPaid; 
  }




  mapFormValuesToModel(){
    this.invoiceData =[];
    this.receiptData =[];
    var resultInvoice = [];
    var resultReceipt = [];
    var paymentTerm = this.invoiceForm.value.paymentTerm;
    var dueDate = new Date(this.invoiceForm.value.invoiceDate);

  
    switch(paymentTerm){
      case "7 Days":  dueDate.setDate(dueDate.getDate() + 7);
      break;
      case "15 Days": dueDate.setDate(dueDate.getDate() + 15);
      break;
      case "21 Days": dueDate.setDate(dueDate.getDate() + 21);
      break;
      case "30 Days": dueDate.setDate(dueDate.getDate() + 30);
      break;
      case "45 Days": dueDate.setDate(dueDate.getDate() + 45);
      break;
      case "60 Days": dueDate.setDate(dueDate.getDate() + 60);
      break;
      case "90 Days": dueDate.setDate(dueDate.getDate() + 90);
      break;
      case "120 Days": dueDate.setDate(dueDate.getDate() + 120);
      break;
      default : dueDate =null;
      break;
    }

    for(let i=0; i < this.getInvoiceItems.length; i++){

      this.invoice.invoiceNo=this.invoiceForm.value.invoiceNo;
      this.invoice.invoiceDate=this.invoiceForm.value.invoiceDate;
      this.invoice.invoiceType=this.invoiceForm.value.invoiceType;
      this.invoice.cusId=this.invoiceForm.value.cusId;
      this.invoice.cusName=this.invoiceForm.value.cusName;
      this.invoice.address=this.invoiceForm.value.address;
      this.invoice.factoryLocation=this.invoiceForm.value.factoryLocation;
      this.invoice.requestedBy=this.invoiceForm.value.requestedBy;
      this.invoice.vatNo=this.invoiceForm.value.vatNo;
      this.invoice.svatNo=this.invoiceForm.value.svatNo;
      this.invoice.poNo=this.invoiceForm.value.poNo;
      this.invoice.vehicle=this.invoiceForm.value.vehicle;
      this.invoice.vehicleType=this.invoiceForm.value.vehicleType;
      this.invoice.containerType=this.invoiceForm.value.containerType;
      this.invoice.containerNo=this.invoiceForm.value.containerNo;
      this.invoice.fromLocation=this.invoiceForm.value.fromLocation;
      this.invoice.toLocation=this.invoiceForm.value.toLocation;
      this.invoice.hireType=this.invoiceForm.value.hireType;
      this.invoice.hireMode=this.invoiceForm.value.hireMode;
      this.invoice.requestTime=moment(this.invoiceForm.value.requestTime).format("YYYY-MM-DD HH:mm");
      this.invoice.factoryInTime=moment(this.invoiceForm.value.factoryInTime).format("YYYY-MM-DD HH:mm");
      this.invoice.detentionStartTime=moment(this.invoiceForm.value.detentionStartTime).format("YYYY-MM-DD HH:mm");
      this.invoice.finishedTime=moment(this.invoiceForm.value.finishedTime).format("YYYY-MM-DD HH:mm");
      this.invoice.chargingHours=this.invoiceForm.value.chargingHours;
      this.invoice.jobNo=this.invoiceForm.value.jobNo;
      this.invoice.paymentTerm=this.invoiceForm.value.paymentTerm;
      this.invoice.dueDate= null;
      if(this.invoice.paymentTerm!=="COD"){
        this.invoice.dueDate= moment(dueDate).format("YYYY-MM-DD");
      }
   
  
    this.invoice.itemCode = this.getInvoiceItems.value[i].itemCode
    this.invoice.description=this.getInvoiceItems.value[i].description;
    this.invoice.salesType=this.getInvoiceItems.value[i].salesType;
    this.invoice.unitPrice=this.getInvoiceItems.value[i].unitPrice;
    this.invoice.qty=this.getInvoiceItems.value[i].qty;
    this.invoice.amount=this.getInvoiceItems.value[i].amount;

    this.invoice.subTotal=this.invoice.subTotal;
    this.invoice.vat =this.invoice.vat
    this.invoice.grandTotal=this.invoice.grandTotal;
    this.invoice.totalCost = this.getInvoiceItems.value.reduce((prev,curr)=>prev + +(curr.unitCost * curr.qty), 0);
    this.invoice.totalProfit=this.invoice.grandTotal - this.invoice.totalCost;
    this.invoice.balToPay= this.invoice.balToPay;
    this.invoice.amountPaid=this.invoice.amountPaid;
    this.invoice.remarks = this.invoiceForm.value.remarks;

    if (this.invoice.amountPaid == 0)
    {
      this.invoice.status = "Unpaid";
    }
    else if (this.invoice.amountPaid == this.invoice.grandTotal)
    {
      this.invoice.status = "Paid";
    }
    else
    {
      this.invoice.status = "Partially paid";
    }

    this.invoice.type='Sale';
    this.invoice.refNo='';
    this.invoice.createdBy =this.authService.getUserLoggedIn();
    
    this.invoiceData.push(
      this.invoice.invoiceNo,
      this.invoice.invoiceDate,
      this.invoice.invoiceType,
      this.invoice.cusId,
      this.invoice.cusName,
      this.invoice.address,
      this.invoice.factoryLocation,
      this.invoice.requestedBy,
      this.invoice.vatNo,
      this.invoice.svatNo,
      this.invoice.vehicle,
      this.invoice.vehicleType,
      this.invoice.containerType,
      this.invoice.containerNo,
      this.invoice.fromLocation,
      this.invoice.toLocation,
      this.invoice.hireType,
      this.invoice.hireMode,
      this.invoice.requestTime,
      this.invoice.factoryInTime,
      this.invoice.detentionStartTime,
      this.invoice.finishedTime,
      this.invoice.chargingHours,
      this.invoice.jobNo,
      this.invoice.paymentTerm,
      this.invoice.dueDate, //26
      this.invoice.poNo, //26
   
          
      this.invoice.itemCode,
      this.invoice.description,
      this.invoice.salesType,
      this.invoice.unitPrice,
      this.invoice.qty,
      this.invoice.amount, //32

      this.invoice.subTotal,   
      this.invoice.vat,
      this.invoice.grandTotal,
      this.invoice.totalCost,
      this.invoice.totalProfit,
      this.invoice.balToPay,
      this.invoice.amountPaid, //39

      this.invoice.remarks,
      this.invoice.status,
      this.invoice.type,
      this.invoice.refNo,
      this.invoice.createdBy,  //45

      );

    }

  if(this.receiptNo){

    this.receiptData.push(
      this.receiptNo,
      this.invoice.invoiceDate,
      this.paymentType,
      this.invoice.cusId,
      this.invoice.cusName,
      this.invoice.address,
      this.depositAccount,
      null,
      this.invoice.amountPaid,
      this.invoice.invoiceDate,
      this.invoice.invoiceNo,
      this.invoice.grandTotal,
      this.invoice.grandTotal,
      this.invoice.amountPaid,
      this.invoice.status,
      this.invoice.createdBy,     
      );

    }

    while(this.invoiceData.length){
      resultInvoice.push(this.invoiceData.splice(0,45));
    }
  
    while(this.receiptData.length){
      resultReceipt.push(this.receiptData.splice(0,16));
    }


   // return result;
   return [resultInvoice,resultReceipt];

  }

   
  saveButtonClick(): void {
    this.logValidationErrors(this.invoiceForm,true);
   // console.log(this.amountInWords(this.invoiceForm.value.cusName,'Rupees','Cent'));
    const [invoiceData,receiptData] = this.mapFormValuesToModel();
    const body = {invoiceData : invoiceData, receiptData : receiptData}

    if(this.isFilledFromFields()){
        this.showProcessingIndicator = true;

        if(!this.invoiceForm.value.id){

          this.invoiceService.addInvoice(body)
          .subscribe(
            (res) =>{               
                if(res.success === 0){
                  this.invoiceForm.patchValue({
                    invoiceNo : res.autoId
                  });
                this.saveButtonClick();
                this.showProcessingIndicator = false; 
              }else if(res.success === 1){
                this.toastr.success('Invoice created successfully','Success');
                this.isfieldReadOnly  = true;
                this.isBtnDisabled = true;
                this.isEditBtnDisabled = true;
                this.isHideBtn = true;
                this.isShowAttachBtn = true;
                this.isCancelBtnDisabled = false;
                this.disableForm(); 
                this.showProcessingIndicator = false;   
              }   
                  
         
            },
            (err) =>{ 
              this.toastr.error('Failed to create invoice','Failure'); 
              this.showProcessingIndicator = false;   
              if(err instanceof HttpErrorResponse){                 
                if(err.status == 401){
                  this.router.navigate(['/login']);
                }
              }
              console.log(err);
            }
          )

        } //end Insert
        else{
          this.dialogService.openConfirmDialog('Are you sure you want to update this invoice?')
          .afterClosed().subscribe(res =>{
            if(res){
      
           this.invoiceService.updateInvoice(body)
           .subscribe(
             (res) => {
                         this.toastr.success('Invoice Updated successfully','Success');   
                         this.isfieldReadOnly  = true;
                         this.isBtnDisabled = true;
                         this.isEditBtnDisabled = true;
                         this.isHideBtn = true;
                         this.isShowAttachBtn = true;
                         this.isCancelBtnDisabled = false;
                         this.disableForm(); 
                         this.showProcessingIndicator = false;     
                       },        
             (err) =>  {
                         this.toastr.error('Failed to update invoice','Failure');
                         if(err instanceof HttpErrorResponse){                 
                          if(err.status == 401){
                            this.router.navigate(['/login']);
                          }
                        }
                        console.log(err);
                        this.showProcessingIndicator = false; 
                       }, 
               )
      
           } 
         });


        }

        } ///end chck empty

    else{
          this.toastr.warning('Required Fields cannot be empty or invalid.','Error Message');
          this.showProcessingIndicator = false;                                                                                                                                                                                                   
        } 
   }

   deleteButtonClick(){   
    var invoiceNo = this.invoiceForm.get('invoiceNo').value;
    if(invoiceNo){
    this.dialogService.openConfirmDialog('Are you sure you want to delete this invoice?')
    .afterClosed().subscribe(res =>{
      if(res){

      const [invoiceData,receiptData] = this.mapFormValuesToModel();
      const body = {invoiceData : invoiceData, receiptData : receiptData}

     this.invoiceService.deleteInvoice(body,invoiceNo)
     .subscribe(
       (res) => {
                   this.toastr.success('Invoice deleted successfully','Success');
                   this.newButtonClick();
                   console.log(res);     
                 },        
       (err) =>  {
                   this.toastr.error('Failed to delete invoice','Failure');
                   if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                 }, 
         )

     } 
   });
  }
}

   enableForm():void{
    Object.keys(this.invoiceForm.controls).forEach(key => {
      this.invoiceForm.controls[key].enable();
      //console.log("Enable "+key)     
    });

  }


  disableForm():void{
    Object.keys(this.invoiceForm.controls).forEach(key => {
      this.invoiceForm.controls[key].disable();
     // console.log("disable "+key);
    });

  }
  
  logValidationErrors(group: FormGroup = this.invoiceForm,isDirty :boolean=false): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      this.formErrors[key] = '';
      if(isDirty)
      {
        this.enableForm();
        this.invoiceForm.controls[key].markAsTouched();
      }
        if (abstractControl && !abstractControl.valid && (abstractControl.touched || abstractControl.dirty)) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey) {
              this.formErrors[key] += messages[errorKey] + ' ';
            }
          }
        }

      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } 
    });
  }

  isFilledFromFields() : boolean {
    (<FormArray>this.invoiceForm.get('invoiceItems')).controls.forEach((group: FormGroup) => {
      (<any>Object).values(group.controls).forEach((control: FormControl) => { 
          control.markAsTouched();
      }) 
    });

    var value = this.invoiceForm.value.cusId;
    if(!value){
      this.invoiceForm.patchValue({ cusId :  null,cusName :  null, address : null });    
    }

    for (var key in this.formErrors) {
      if (this.formErrors[key] !== null && this.formErrors[key] != "" && this.formErrors[key] != '')
          return false;
        }

        if(this.getInvoiceItems.length==0 || this.invoiceForm.get('invoiceItems').invalid){
            return false;
          }

        return true;
  }

 



    viewInvoiceById(){
        var hasInvoiceNo;
        var invoiceNo;

          hasInvoiceNo =this.route.snapshot.queryParamMap.has('invoiceNo');
         
          if(hasInvoiceNo){
            invoiceNo = this.route.snapshot.queryParamMap.get('invoiceNo')
      
            this.invoiceService.getInvoice(invoiceNo)
            .subscribe(
              (data) => {
                        if(data){                         
                          this.isCancelBtnDisabled = false;
                          this.isEditBtnDisabled = false;
                          this.patchValuesToForm(data); 
                          this.isBtnDisabled = true;
                          this.disableForm(); 
                          this.isfieldReadOnly = true;    
                          this.isHideBtn = true;                    
                          this.showInvoicePmtDetails = true;    
                          this.bsClassToShow = true;      
                          this.isShowAttachBtn = true;                  
                         }
                        },
            (err) => 
                      {
                        if(err instanceof HttpErrorResponse){                 
                          if(err.status == 401){
                            this.router.navigate(['/login']);
                          }
                        }
                        console.log(err);
                      });
      }else{
        this.newButtonClick();
      }

    }

patchValuesToForm(data){

  this.invoiceForm.patchValue({  
    id:data[0].Id,
    invoiceNo:data[0].InvoiceNo,
    invoiceDate:moment(data[0].InvoiceDate).format("YYYY-MM-DD"),
    invoiceType:data[0].InvoiceType,
    cusId:data[0].CusId,
    cusName:data[0].CusName,
    address:data[0].Address,
    factoryLocation:data[0].FactoryLocation,
    requestedBy:data[0].RequestedBy,
    vatNo:data[0].VATNo,
    svatNo:data[0].SVATNo,
    vehicle:data[0].Vehicle,
    vehicleType:data[0].VehicleType,
    containerType:data[0].ContainerType,
    containerNo:data[0].ContainerNo,
    fromLocation:data[0].FromLocation,
    toLocation:data[0].ToLocation,
    hireType:data[0].HireType,
    hireMode:data[0].HireMode,
    requestTime:data[0].RequestTime ? moment(data[0].RequestTime).format("YYYY-MM-DD HH:mm"):null,
    factoryInTime:data[0].FactoryInTime ? moment(data[0].FactoryInTime).format("YYYY-MM-DD HH:mm"):null,
    detentionStartTime:data[0].DetentionStartTime ? moment(data[0].DetentionStartTime).format("YYYY-MM-DD HH:mm"):null,
    finishedTime:data[0].FinishedTime ? moment(data[0].FinishedTime).format("YYYY-MM-DD HH:mm"):null,
    chargingHours:data[0].ChargingHours,
    jobNo:data[0].JobNo,
    paymentTerm:data[0].PaymentTerm,
    dueDate:data[0].DueDate,
    poNo:data[0].PoNo,
    remarks:data[0].Remarks,

  });
  
  this.invoiceForm.setControl('invoiceItems',this.setInvoiceItems(data));
  this.invoice.subTotal= data[0].SubTotal;
  this.invoice.vat = data[0].Vat;
  this.invoice.grandTotal = data[0].GrandTotal,

  this.invoice.status = data[0].Status;
  this.invoice.amountPaid = data[0].AmountPaid;
  this.invoice.balToPay = data[0].BalToPay;

  this.invoice.dueDate = data[0].DueDate,
  this.invoice.createdBy = data[0].CreatedBy,

  this.isShowPayBtn = true;
  if(data[0].Status==='Paid' || data[0].Status==='Partially paid'){
    this.isCancelBtnDisabled = true;
    this.isEditBtnDisabled = true;
    this.isShowPayBtn = false;
  }

}


  setInvoiceItems(data) : FormArray{
    const invoiceItemArray = new FormArray([]);
    for(let i =0; i < data.length;i++){ 
      invoiceItemArray.push(this.fb.group({
        itemCode : [data[i].ItemCode,Validators.required],
        description : [data[i].Description,Validators.required],
        salesType : [data[i].SalesType],
        unitCost : [''],
        unitPrice : [data[i].UnitPrice,Validators.required],
        qty : [data[i].Qty,Validators.required],
        amount : [data[i].Amount,Validators.required],   
       
      }));
    }
    return invoiceItemArray;
  }




attachFileButtonClick(){
 this.fileUploadService.refNo = this.invoiceForm.value.invoiceNo;
  const dialogConfig = new MatDialogConfig();
  dialogConfig.disableClose = true;
  dialogConfig.autoFocus = true;
  dialogConfig.width = "75%";
   this.dialogService.openDialog(FileUploadComponent,dialogConfig)
   .afterClosed().subscribe(res => {
    //this.getAll()
   });  
 }

 payButtonClicked(){  
   var invoiceNo = this.invoiceForm.value.invoiceNo;
  this.router.navigate(['../receipt'],{queryParams : {'invoiceNo':invoiceNo},relativeTo : this.route});            
 }


   savePDF(action){
     
   
   const documentDefinition = { 
      pageSize: 'A4',
      pageOrientation: 'portrait',  
      pageMargins: [40, 40, 40, 60],
 
      content: [ 
          
        {
          columns :  [ 
          
            { image:this.logo,            
              width: 130,
              height: 70,
            },
            
            [
              {
                text: this.companyData[0].CompanyName,  
                margin: [20, 0, 0, 0],
                bold: true,
                fontSize: 14,
                width : '*'
              },
              {
              columns: [
                  [
                    { text: this.companyData[0].Address,  width : '*',  margin: [20, 0, 0, 0]},  
                    { text: `Tel: ${this.companyData[0].Phone}`, width : '*',  margin: [20, 0, 0, 0]},  
                    { text: `Email: ${this.companyData[0].Email}`,  width : '*',  margin: [20, 0, 0, 0] },
                    { text: `Web: ${this.companyData[0].Web}`,  width : '*', margin: [20, 0, 0, 0] }  
                  ],
                  [ 
                    `\n\n`,
                    { text: `Invoice No   : ${this.invoiceForm.value.invoiceNo}`,  margin: [20, 0, 0, 0]},
                    { text: `Invoice Date : ${moment(this.invoiceForm.value.invoiceDate).format("YYYY-MM-DD")}`,  margin: [20, 0, 0, 0]},

                  ]
                ]
             }
            ]
                
          ]
        },  

      //   {  
      //     table: {    
      //         widths: ['*'],  
      //         body: [  
      //           [
      //             { text:'INVOICE',alignment:'center', border: [false, true, false, true], margin: [0, 10, 0, 0], width: 'auto',bold: true, fontSize: 18},
      //           ],         
      //         ],           
      //   },      
      // },
      { text:'INVOICE',alignment:'center', border: [false, true, false, true], margin: [0, 10, 0, 0], width: 'auto',bold: true, fontSize: 22},
  
        {
          columns : [
         
            [
              
              { text: 'Bill To :', margin: [0, 10, 0, 5],   fontSize: 12,},  
              { text: this.invoiceForm.value.cusName,margin: [0, 0, 0, 0], bold:true,   fontSize: 12, },  
              { text: this.invoiceForm.value.address,margin: [0, 0, 0, 0] },  
              { text: this.invoiceForm.value.factoryLocation ? `FACTORY LOCATION: ${this.invoiceForm.value.factoryLocation}` : null,margin: [0, 10, 0, 0] },  

            ],
            [
              { text: this.invoiceForm.value.requestTime ? `Request Time              : ${moment(this.invoiceForm.value.requestTime).format("YYYY-MM-DD  HH:mm")}` : '',width: 'auto',margin: [25, 10, 0, 0],   fontSize: 12, },  
              { text: this.invoiceForm.value.factoryInTime ? `Factory In Time           : ${moment(this.invoiceForm.value.factoryInTime).format("YYYY-MM-DD  HH:mm")}` : '',width: 'auto',margin: [25, 0, 0, 0],   fontSize: 12, },  
              { text: this.invoiceForm.value.detentionStartTime ? `Detention Start Time  : ${moment(this.invoiceForm.value.detentionStartTime).format("YYYY-MM-DD  HH:mm")}` : '',width: 'auto',margin: [25, 0, 0, 0],   fontSize: 12, },  
              { text: this.invoiceForm.value.finishedTime ? `Finished Time              : ${moment(this.invoiceForm.value.finishedTime).format("YYYY-MM-DD  HH:mm")}` : '',width: 'auto',margin: [25, 0, 0, 0],   fontSize: 12, },  
              { text: this.invoiceForm.value.vehicle ? `Vehicle                          : ${this.invoiceForm.value.vehicle}` :'' ,width: 'auto',   fontSize: 12, margin: [25, 0, 0, 0] },
              { text: this.invoiceForm.value.containerNo ? `Container No               : ${this.invoiceForm.value.containerNo}` :'' ,width: 'auto',   fontSize: 12, margin: [25, 0, 0, 0] },
              { text: this.invoiceForm.value.containerType ? `Container Type            : ${this.invoiceForm.value.containerType}` :'' ,width: 'auto',   fontSize: 12, margin: [25, 0, 0, 0] },
              { text: this.invoiceForm.value.poNo ? `PO No.                          : ${this.invoiceForm.value.poNo}` :'' ,width: 'auto',   fontSize: 12, margin: [25, 0, 0, 0] },

            ],

          ]

        },

        '\n',
        { 
          layout: {
          defaultBorder: false,
          hLineWidth: function(i, node) {
            return 1;
          },
          vLineWidth: function(i, node) {
            return 1;
          },
          hLineColor: function(i, node) {
              return '#bfdde8';        
          },
          vLineColor: function(i, node) {
            return '#eaeaea';
          },
          hLineStyle: function(i, node) {
            // if (i === 0 || i === node.table.body.length) {
            return null;
            //}
          },
          // vLineStyle: function (i, node) { return {dash: { length: 10, space: 4 }}; },
          paddingLeft: function(i, node) {
            return 10;
          },
          paddingRight: function(i, node) {
            return 10;
          },
          paddingTop: function(i, node) {
            return 3;
          },
          paddingBottom: function(i, node) {
            return 3;
          },
          fillColor: function(rowIndex, node, columnIndex) {
            return '#fff';
          },
        },
          width: 'auto', 
          fontSize: 12,            
          table: {
          headerRows: 1,
          widths: ['15%', '12%','22%', '12%','13%', '*'],
              body: [
              [
                {
                  text: 'Hire Type',
                  bold: true,
                  fillColor: '#eaf2f5',
                  border: [true, true, true, true],
                  margin: [0, 5, 0, 5],
                },
                {
                  text: this.invoiceForm.value.hireType,
                  bold: true,          
                  border: [true, true, true, true],            
                  margin: [0, 5, 0, 5],
                },
                {
                  text: 'Job No',
                  bold: true,
                  fillColor: '#eaf2f5',
                  border: [true, true, true, true],
                  margin: [0, 5, 0, 5],
                },
                {
                  text: this.invoiceForm.value.jobNo,
                  bold: true,          
                  border: [true, true, true, true],
                  margin: [0, 5, 0, 5],
                },
                {
                  text: 'From',
                  bold: true,
                  fillColor: '#eaf2f5',
                  border: [true, true, true, true],
                  margin: [0, 5, 0, 5],
                },
                {
                  text: this.invoiceForm.value.fromLocation,
                  bold: true,          
                  border: [true, true, true, true],
                  margin: [0, 5, 0, 5],
                },
              ],
              [
                {
                  text: 'Hire Mode',
                  bold: true,
                  fillColor: '#eaf2f5',
                  border: [true, true, true, true],
                  margin: [0, 5, 0, 5],
                },
                {
                  text: this.invoiceForm.value.hireMode,
                  bold: true,          
                  border: [true, true, true, true],
                  margin: [0, 5, 0, 5],
                },
                {
                  text: 'Payment Term',
                  bold: true,
                  fillColor: '#eaf2f5',
                  border: [true, true, true, true],
                  margin: [0, 5, 0, 5],
                },
                {
                  text: this.invoiceForm.value.paymentTerm,
                  bold: true,          
                  border: [true, true, true, true],
                  margin: [0, 5, 0, 5],
                },
                {
                  text: 'To',
                  bold: true,
                  //fillColor: '#f5f5f5',
                  fillColor: '#eaf2f5',
                  border: [true, true, true, true],
                  margin: [0, 5, 0, 5],
                },
                {
                  text: this.invoiceForm.value.toLocation,
                  bold: true,          
                  border: [true, true, true, true],
                  margin: [0, 5, 0, 5],
                },
              ],
            ],
          },
        }, 

        '\n',
                           
        {  
          layout: {
            defaultBorder: false,
            hLineWidth: function(i, node) {
              return 1;
            },
            vLineWidth: function(i, node) {
              return 1;
            },
            hLineColor: function(i, node) {
              if (i === 1 || i === 0) {
                return '#bfdde8';
              }
              return '#eaeaea';
            },
            vLineColor: function(i, node) {
              return '#eaeaea';
            },
            hLineStyle: function(i, node) {
              // if (i === 0 || i === node.table.body.length) {
              return null;
              //}
            },
            // vLineStyle: function (i, node) { return {dash: { length: 10, space: 4 }}; },
            paddingLeft: function(i, node) {
              return 10;
            },
            paddingRight: function(i, node) {
              return 10;
            },
            paddingTop: function(i, node) {
              return 2;
            },
            paddingBottom: function(i, node) {
              return 2;
            },
            fillColor: function(rowIndex, node, columnIndex) {
              return '#fff';
            },
          },
          table: {  
             
              headerRows: 1,  
              widths: ['*', 'auto','auto', 'auto'],  
              body: [  
                [
                 { text: 'Description', style:'tableFont',fillColor: '#eaf2f5', border: [false, true, false, true],   margin: [0, 5, 0, 5]},
                 { text: 'UnitPrice', style:'tableFont',fillColor: '#eaf2f5', border: [false, true, false, true],   margin: [0, 5, 0, 5]},
                 { text: 'Qty', style:'tableFont',fillColor: '#eaf2f5', border: [false, true, false, true],   margin: [0, 5, 0, 5]},
                 { text: 'Amount', style:'tableFont',fillColor: '#eaf2f5', border: [false, true, false, true],   margin: [0, 5, 0, 5]}],
                ...this.getInvoiceItems.value.map(p => ([{ text :p.description, border: [false, false, false, true],  margin: [0, 5, 0, 5],style:'tableFont'}, {text : this.transformNumberFormat(p.unitPrice), border: [false, false, false, true], margin: [0, 5, 0, 5], alignment: 'right',style:'tableFont' }, { text : this.transformNumberFormat(p.qty), border: [false, false, false, true],margin: [0, 5, 0, 5],alignment: 'right',style:'tableFont'  }, { text: this.transformNumberFormat(p.amount), border: [false, false, false, true],margin: [0, 5, 0, 5],alignment: 'right',style:'tableFont' }])),               
              ]           
        }       
      },

      '\n',
      {
        columns : [
              [    
                {text: this.invoiceForm.value.remarks ?  `Remarks : ${this.invoiceForm.value.remarks}`: null,fontSize: 10, alignment: 'left', margin: [0, 5, 0, 5]}, 
                '\n',
                '\n\n',      
                {alignment:'left',canvas: [{ margin: [0, 50, 0, 5], type: 'line', x1: 0, y1: 5, x2: 200, y2: 5, lineWidth: 1,lineColor: '#808080',dash: { length: 2 }, }]},
                {text: 'Maritime Freight System (Pvt) Ltd', alignment: 'left', margin: [0, 5, 0, 5]},
              ], 
                       
              { 
                layout: {
                defaultBorder: false,
                hLineWidth: function(i, node) {
                  return 1;
                },
                vLineWidth: function(i, node) {
                  return 1;
                },
                hLineColor: function(i, node) {
                  return '#eaeaea';
                },
                vLineColor: function(i, node) {
                  return '#eaeaea';
                },
                hLineStyle: function(i, node) {
                  // if (i === 0 || i === node.table.body.length) {
                  return null;
                  //}
                },
                // vLineStyle: function (i, node) { return {dash: { length: 10, space: 4 }}; },
                paddingLeft: function(i, node) {
                  return 10;
                },
                paddingRight: function(i, node) {
                  return 10;
                },
                paddingTop: function(i, node) {
                  return 3;
                },
                paddingBottom: function(i, node) {
                  return 3;
                },
                fillColor: function(rowIndex, node, columnIndex) {
                  return '#fff';
                },
              },
                width: 'auto', 
                fontSize: 12,            
                table: {
                headerRows: 1,
                widths: ['auto', 'auto'],
                    body: [
                    [
                      {
                        text: 'Grand Total',
                        bold: true,
                        alignment: 'right',
                        fillColor: '#eaf2f5',
                        border: [false, false, false, true],
                        margin: [0, 5, 0, 5],
                      },
                      {
                        text: this.transformNumberFormat(this.invoice.grandTotal),
                        bold: true,          
                        alignment: 'right',
                        border: [false, false, false, true],                  
                        margin: [0, 5, 0, 5],
                      },
                    ],
                    [
                      {
                        text: 'Paid',
                        bold: true,
                        alignment: 'right',
                        fillColor: '#eaf2f5',
                        border: [false, false, false, true],
                        margin: [0, 5, 0, 5],
                      },
                      {
                        text: this.transformNumberFormat(this.invoice.amountPaid),
                        bold: true,          
                        alignment: 'right',
                        border: [false, false, false, true],
                        margin: [0, 5, 0, 5],
                      },
                    ],
                    [
                      {
                        text: 'Due',
                        bold: true,
                        alignment: 'right',
                        fillColor: '#eaf2f5',
                        border: [false, false, false, true],
                        margin: [0, 5, 0, 5],
                      },
                      {
                        text: this.transformNumberFormat(this.invoice.balToPay),
                        bold: true,          
                        alignment: 'right',
                        border: [false, false, false, true],
                        margin: [0, 5, 0, 5],
                      },
                    ],
                  ],
                },
              },         
        ]

      },

      '\n',
      {  
        style: 'tableExample',
        table: {    
          dontBreakRows:true,
          unbreakable: true,
            widths: ['25%%', '25%'],  
            body: [  
              [
                { text:'BANK NAME',   margin: [0, 0, 0, 0]},
                { text:'HNB - KATUNAYAKE',   margin: [0, 0, 0, 0]}
              ],         
               [
                 {text : 'ACCOUNT NO.',  margin: [0, 0, 0, 0]},  
                 { text:'049010019596',   margin: [0, 0, 0, 0]}              
               ], 
               [
                {text : 'SWIFT CODE',   margin: [0, 0, 0, 0]},  
                { text:'HBLILKLX001',  margin: [0, 0, 0, 0]}              
              ], 
            ],           
      },      
    },


  ],  // end content

  footer: ()=> {

    return [
    
      { margin: [40, 5, 40, 10],canvas: [{type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 1 } ]},
      { text: `Cheque should be drawn in favour of "Maritime Freight System (Pvt) Ltd" & cross A/C Payee only`,  margin: [75, 0, 40, 0],width: 'auto',bold: true, fontSize: 10},
  
    ]
    
     },

  
  

 
      styles: {  
        reportHeader: {  
            bold: true,  
            decoration: 'underline',  
            fontSize: 14,  
            margin: [0, 15, 0, 15],
            alignment: 'center',             
        },
        tableFont: {  
          fontSize: 10,  
           
      
        }       
    } 
      
      
     };// end 


      if(action==='open'){    
            pdfMake.createPdf(documentDefinition).open();  
          
        }else if(action === 'print'){    
            pdfMake.createPdf(documentDefinition).print();          
        }
        else if(action === 'download'){    
          pdfMake.createPdf(documentDefinition).download(`Invoice-${this.invoiceForm.value.invoiceNo}`);     
      }


   }


   transformNumberFormat(number) {
    return this.decimalPipe.transform(number,'1.2-2');
   }


  customizeAmountToWords(amount){
    var words = new Array();
    words[0] = 'zero';words[1] = 'One';words[2] = 'Two';words[3] = 'Three';words[4] = 'Four';words[5] = 'Five';words[6] = 'Six';words[7] = 'Seven';words[8] = 'Eight';words[9] = 'Nine';words[10] = 'Ten';words[11] = 'Eleven';words[12] = 'Twelve';words[13] = 'Thirteen';words[14] = 'Fourteen';words[15] = 'Fifteen';words[16] = 'Sixteen';words[17] = 'Seventeen';words[18] = 'Eighteen';words[19] = 'Nineteen';words[20] = 'Twenty';words[30] = 'Thirty';words[40] = 'Forty';words[50] = 'Fifty';words[60] = 'Sixty';words[70] = 'Seventy';words[80] = 'Eighty';words[90] = 'Ninety'; words[100] = 'One Hundred'; words[200] = 'Two Hundred'; words[300] = 'Three Hundred'; words[400] = 'Four Hundred'; words[500] = 'Five Hundred'; words[600] = 'Six Hundred'; words[700] = 'Seven Hundred'; words[800] = 'Eight Hundred'; words[900] = 'Nine Hundred';
    amount = amount.toString();
    var atemp = amount.split('.');
    var number = atemp[0].split(',').join('');
    var n_length = number.length;
    var words_string = '';

    if(n_length <= 11){
    var n_array = new Array(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    var received_n_array = new Array();

    for (var i = 0; i < n_length; i++){
    received_n_array[i] = number.substr(i, 1);
    }

    for (var i = 11 - n_length, j = 0; i < 11; i++, j++){
    n_array[i] = received_n_array[j];  
    }

    for (var i = 0, j = 1; i < 11; i++, j++){
    if(i == 0 || i == 3 || i == 6 || i == 9){
      if(n_array[i] == 1){
        n_array[j] = 10 + (n_array[j]);
        n_array[i] = 0;
       }
     }
   }


    let value;;
    for (var i = 0; i < 11; i++){

    if(i == 0 || i == 3 || i == 6 || i == 9){
    value = n_array[i] * 10;
    }else if( i == 2 || i == 5 || i == 8){
    value = n_array[i] * 100;
    }else{
    value = n_array[i];
   }
    
    if(value != 0){
     words_string += words[value] + ' ';
    }

    if((i == 1 && value != 0) && (n_array[i - 1] > 0)){
    words_string += 'Billion ';
    }else if(( i == 1) && value != 0){
    words_string += 'Biillion ';
    }
    if((i == 4) && value == 0 && (n_array[i - 1] > 0 || n_array[i - 2] > 0)){
    words_string += 'Million ';
    } else if(( i == 4) && value != 0){
    words_string += 'Million ';
    }

    if((i == 7) && value == 0 && (n_array[i - 1] > 0 || n_array[i - 2] > 0)){
    words_string += 'Thousand ';
    } else if(( i == 7) && value != 0){
    words_string += 'Thousand ';
    }

    }

    words_string = words_string.split(' ').join(' ');

    }
    return words_string;

   } // end dolloer cove
    

   amountInWords(amt,cur,frac){
    let op;
    let nums = amt.toString().split('.')
    var whole = this.customizeAmountToWords(nums[0])
    if(nums[1]==null)nums[1]=0;
    if(nums[1].length == 1 )nums[1]=nums[1]+'0';
    if(nums[1].length> 2){nums[1]=nums[1].substring(2,length - 1)}
    if(nums.length == 2){
    if(nums[0]<=12){nums[0]=nums[0]*10} else {nums[0]=nums[0]};

    var fraction = this.customizeAmountToWords(nums[1])

    if(whole=='' && fraction==''){op='Zero only';}
    if(whole=='' && fraction!=''){op=`${fraction} ${frac} only`;}
    if(whole!='' && fraction==''){op=`${whole} ${cur} only`;} 
    if(whole!='' && fraction!=''){op=`${whole} ${cur} and ${fraction} ${frac} only`;}


    if(amt > 99999999999.99){
      op='Oops!!! The amount is too big to convert';
    }
    if(isNaN(amt) == true ){
      op='Error : Amount in number appears to be incorrect. Please Check.';
    }
   
     return op;

    }

  }
   
    


    } // end class
